<template>
    <div class="avatar" v-bind:style="styles">
    </div>
</template>

<script>
    export default {
        name: 'Avatar',

        props: {
            url: {
                required: true,
            },
            width: {
                required: false,
                default: '17px',
            },
            height: {
                required: false,
                default: '17px',
            },
            borderColor: {
                default : "edf0f0",
            },
        },
        computed : {

            styles() {
                return {
                    backgroundImage : 'url('+this.url+')',
                    width : this.width,
                    height : this.height,
                    'min-width' : this.width,
                    'border-color' : this.borderColor,
                    'vertical-align': 'middle',
                };
            },
        }
    }
</script>

<style>
    .avatar{
        background-size: cover;
        background-position: center center;
        border-radius: 50%;
        border: 2px solid #edf0f0;
        display: inline-block;
    }
</style>
